import type { CommerceErrorCode, CommerceOperationOptions } from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
import { CommerceOperationExecutor } from "../execution/commerce-operation-executor.js";

export abstract class CommerceRepository {
    public constructor(protected readonly executor: CommerceOperationExecutor) {}

    protected execute<TRequest, TResponse>(
        operation: CommerceOperation<TRequest, TResponse>,
        request: TRequest,
        options: CommerceOperationOptions,
        errorCode: CommerceErrorCode,
        errorMessage: string,
        details: Readonly<Record<string, unknown>> = {},
    ): Promise<TResponse> {
        return this.executor.execute(operation, request, options, errorCode, errorMessage, details);
    }
}
